import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./BrandFlag.module.css";

type Props = { to?: string; "aria-label"?: string };

/**
 * Das brings-mit.com-Flag — Text-Schriftzug mit Subtitle in der aktuellen
 * UI-Sprache, eingefasst in eine Flag mit dünnen vertikalen gestrichelten
 * Linien links und rechts (Wimpel-Optik).
 */
export function BrandFlag({ to = "/", "aria-label": ariaLabel = "brings-mit.com" }: Props) {
  const { t } = useTranslation();
  return (
    <Link to={to} className={styles.flag} aria-label={ariaLabel}>
      <span className={styles.name}>
        brings<span className={styles.dot}>-</span>mit<span className={styles.dot}>.</span>com
      </span>
      <span className={styles.subtitle}>{t("app.subtitle")}</span>
    </Link>
  );
}
